import { GUEST, SYSTEM_ROLES_MAP, AUTOMATIC_ROLE_NAME_MEMBER, SYSTEM_ROLE_NAME_SYSTEM, SYSTEM_ROLE_NAME_RESELLER, SYSTEM_ROLE_NAME_ACCOUNT } from '../constants/index.js';
export class User {
    _id;
    title;
    locale;
    reseller;
    roles;
    active;
    deleted;
}
//export const GUEST_ID = '00000000-0000-0000-0000-000000000000';
export const isGuest = (user) => !user || user._id === GUEST._id;
const hasSystemRole = (user, roleName) => !!user && user.roles && user.roles.includes(SYSTEM_ROLES_MAP[roleName]._id);
export const isMember = (user) => hasSystemRole(user, AUTOMATIC_ROLE_NAME_MEMBER);
export const isSystemAdministrator = (user) => hasSystemRole(user, SYSTEM_ROLE_NAME_SYSTEM);
export const isResellerAdministrator = (user) => hasSystemRole(user, SYSTEM_ROLE_NAME_RESELLER);
export const isAccountAdministrator = (user) => hasSystemRole(user, SYSTEM_ROLE_NAME_ACCOUNT);
export const isSystemUser = (user) => isAccountAdministrator(user) || isResellerAdministrator(user) || isSystemAdministrator(user);
export const isUser = (user) => !isGuest(user) && !isMember(user) && !isSystemUser(user);
export class UserWithEmail extends User {
    email;
}
export class UserFilter {
    _id;
    email;
    title;
    locale;
    reseller;
    roles;
    active;
    deleted;
}
export class CreateSystemAdministrator {
    email;
    title;
    locale;
    roles;
}
export class CreateAccountAdministrator {
    email;
    title;
    locale;
}
export class CreateDomainUser {
    email;
    title;
    locale;
    roles;
}
export class CreateMember {
    email;
    secret;
    locale;
}
export class UpdateSystemUser {
    title;
    locale;
    active;
    deleted;
}
export class UpdateDomainUser extends UpdateSystemUser {
    roles;
}
export class UserProfile {
    title;
    locale;
}
export class MemberProfile {
    locale;
}
